<template lang="pug">
#DrawFlow
  FactoryDrawFlow(:class="{ 'readOnly': viewMode === 2 || screenShot}" v-if="FlowConfig.length>0" ref="flow" :flow-type="viewMode" :edit-mode="viewMode"
    :flow-config="FlowConfig" @clickNode="clickFlowNode" @closeNode="closeNode" )
  el-drawer(title="发起人配置" :visible.sync="titleDialog" direction="rtl" size="400px" :before-close="titleClose")
    el-form(ref="node" label-position="right" label-width="100px" :model="initiateForm" size="small" :rules="initiateRules")
      el-form-item(label="发起人标题" prop="title")
        el-input(v-model="initiateForm.title" class="input" :disabled="isReadonly" @change="changInitiateNode")
      el-form-item(label="发起人名称" prop="content")
        el-input(v-model="initiateForm.content" class="input" :disabled="isReadonly" @change="changInitiateNode")
  el-drawer(title="流程配置页" custom-class="bgcDrawer" :visible.sync="configDialog" direction="rtl" size="400px" :before-close="configClose")
    .configPage
      el-tabs(v-model="stepName")
        el-tab-pane(label="节点设置" name="nodeSet")
        el-tab-pane(label="表单权限" name="authority" v-if="formFieldPermissionList.length>0")
      el-button.updateFieId(type="text" @click="updateAuthority") 更新当前节点权限
      .configList(v-if="stepName === 'nodeSet'")
        el-form(ref="node" label-position="right" label-width="100px" :model="nodeForm" size="small" :rules="nodeRules")
          el-form-item(label="节点名称" prop="title")
            el-input(v-model="nodeForm.title" class="input" :disabled="isReadonly" @change="changNode")
          el-form-item(label="审批人设置" prop="assigneeSelectionStrategy")
            el-select(v-model="nodeForm.data.assigneeSelectionStrategy" placeholder="请选择" :disabled="isReadonly" @change="changAssNumber")
              el-option(v-for="(item, index) in mockassigneeList" :key="index" :label="item.cnName" :value.sync="item.enName")
          //- 审批人设置为：申请人本身时，不展示 审批时才决定处理人
          el-form-item(props="runtimeSelectUsers" v-if="assigneeSSNumber!=='1'")
            el-checkbox(v-model="nodeForm.data.runtimeSelectUsers" size="small" :true-label="1" :false-label="0" :disabled="isReadonly" @change="changNode") 审批时才决定处理人
            el-popover(placement="bottom-start" width="250" trigger="hover" )
              div 说明：<br/> * 如果勾选了这一项，则流程发起时不会设置节点的审批人，而要推迟到节点审批时才选择。<br/> * 此选项对：指定成员、申请人本人、程序自定义等策略无效。
              i.el-icon-info.tips(slot="reference")
          el-form-item(v-if="showAssigneeList" label="审批人" prop="assigneeList" )
            el-button.addPeople(icon="el-icon-plus" :disabled="isReadonly" size="small" type="text" circle title="选择审批人" @click="openAssPerson") 选择人员、角色或标签
            userItem(:userList="assigneeUserList" :disabled="isReadonly" v-if="assigneeUserList.length>0" @deleteUser="deleteAssUser")
          el-form-item(label="节点说明" v-if="assigneeSSNumber === '5' ")
            el-input(v-model="nodeForm.conditional" class="input" :disabled="isReadonly" @change="changNode")
          el-form-item( label="修改审批人" prop="canChangeAssignee")
            el-radio-group(v-model="nodeForm.data.canChangeAssignee" @change="changNode")
              el-radio(:label="0") 不允许修改审批人
              el-radio(:label="1") 允许在指定范围内修改审批人
          //- 审批人设置为：申请人本身时，不展示 多人审批方式
          el-form-item(label="多人审批方式" prop="multiUserDealStrategy" v-if="assigneeSSNumber!=='1'")
            el-select( v-model="nodeForm.data.multiUserDealStrategy" placeholder="请选择" :disabled="isReadonly" @change="changNode")
              el-option(v-for="(item, index) in multiUserDealStrategyList" :key="index" :label="item.cnName" :value.sync="item.enName")
          el-form-item.ccTop(label="抄送人" prop="ccList")
            el-button.addPeople(icon="el-icon-plus" :disabled="isReadonly" size="small" type="text" circle title="选择抄送" @click="openCCPerson") 选择人员、角色或标签
            userItem(:userList="ccUserList" :disabled="isReadonly" v-if="ccUserList.length>0" @deleteUser="deleteCCUser")
          el-form-item
            //- el-checkbox(v-model="nodeForm.data.ccOptional" size="small" :true-label="1" @change="changNode" :false-label="0" :disabled="isReadonly") 允许申请人自选抄送人
            el-checkbox(v-model="nodeForm.data.ccOneself" size="small" :true-label="1" @change="changNode" :false-label="0" :disabled="isReadonly") 抄送给申请人本人
          el-form-item(label="节点标签" prop="nodeKey")
            el-input(v-model="nodeForm.nodeKey" clearable :disabled="nodeKeyDisabled" maxlength="50" @change="changNode")
          el-form-item.ccTop(label="加签" )
            el-checkbox(v-model="nodeForm.data.allowAddNode" :disabled="isReadonly" :true-label="1" :false-label="0" @change="changNode") 允许加签
            el-popover(placement="bottom-start" title="什么是加签？" width="250" trigger="hover" )
              div * 允许在节点后面临时增加一个审批节点，当节点通过后，转由加签的临时节点处理
              i.el-icon-info.tips(slot="reference")
      .configList(v-if="stepName === 'authority'")
        el-table(:data="permissionTreeList"
          default-expand-all
          row-key="id"
          border
          highlight-current-row
          height="100%"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"  )
          el-table-column(label="字段名"  prop="name"  v-slot="{row}")
            span(v-if="row.name" :title="row.formField") {{row.name}}
            span(v-else) 关联子表
          el-table-column(label="字段权限" align="center")
            el-table-column(label="启用" width="50" align="center" v-slot="{row}")
              el-checkbox(v-model="row.isEnabled" v-if="!row.children?.length"  :true-label="1" :false-label="0"  @change="onIsEnabled(row)")
            el-table-column(label="可见" width="50" prop="isCanView" align="center"  v-slot="{row}" )
              el-checkbox(v-model="row.isCanView" v-if="row.isEnabled===1" :true-label="1" :false-label="0" :disabled="isReadonly" @change="onSaveFieldList")
            el-table-column(label="可写" width="50" prop="isCanUpdate"   align="center" v-slot="{row}" )
              el-checkbox(v-model="row.isCanUpdate" v-if="!row.children?.length&&row.isEnabled===1" :true-label="1" :false-label="0" :disabled="isReadonly" @change="onSaveFieldList")
            el-table-column(label="必填" width="50" prop="isRequired" align="center" v-slot="{row}" )
              el-checkbox(v-model="row.isRequired" v-if="!row.children?.length&&row.isEnabled===1" :true-label="1" :false-label="0" :disabled="isReadonly" @change="onSaveFieldList")
  el-drawer(title="条件分支设置" custom-class="bgcDrawer" :visible.sync="conditionDialog" direction="rtl" size="400px" :before-close="conditionClose")
    .configPage
      el-form(ref="node" label-position="left" label-width="100px" :rules="conditionRules" :model="conditionForm" size="small")
        el-form-item(label="分支名称" prop="title")
          el-input(v-model="conditionForm.title" size="small" :disabled="isReadonly" @change="changeCondition")
        el-form-item(label="条件表达式" prop="content")
          el-input(v-model="conditionForm.content" size="small" :disabled="isReadonly" @change="changeCondition")
        el-form-item(label="条件说明" prop="conditional")
          el-input(v-model="conditionForm.conditional" size="small" :disabled="isReadonly" @change="changeCondition")
          el-button(type="text" @click="openExprEditor") 表达式编辑器
          el-button(type="text" @click="testConditionExpr") 测试表达式
          div.help 关于表达式语法，请参考&nbsp;
            a(target="_blank" href="https://github.com/alibaba/QLExpress") QLExpress 帮助文档
          div.help 示例：
          div.help - 请假天数超过 3 天（含）：leaveDays >= 3
          div.help - 客户类型为 VIP：cusType == 'VIP'
          div.help - 用户姓名中包含公司：userName like '%公司%'
          div.help 重要：表达式中所有的变量都要对应输入的表单字段
        el-form-item(label="条件表达式")
          template(#label)
            span.itemLabel 条件编码
            el-popover(placement="left" width="250" trigger="hover" )
              div 提示：设置 nodeKey 方便业务层代码找到设置正确的参数
              i.el-icon-info.tips(slot="reference")
          el-input(v-model="conditionForm.nodeKey" size="small" :disabled="isReadonly" @change="changeCondition")
  conditionTestDlg(ref="conditionTestDlg")
  exprEditDlg(ref="exprEditDlg" @resolve="finishEditExpr")
</template>

<script>
import EditMode from "@/CommonDP/enums/EditMode";
import { getFlowNode, defaultInitFlowConfig, flowParams } from "../config";
import flowService from "@/CommonDP/service/flow-service";
import metadataService from '@/CommonDP/service/metadata-service';
import dicService from "@/CommonDP/service/dic-service";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { updateNode } from "../config";
import conditionTestDlg from './conditionTestDlg';
import { getFormFieldList } from "../config";
import exprEditDlg from "@/CommonDP/components/custom-dialog/sql/layout.vue";
import Vue from "vue";
import DrawFlow from "@/CommonDP/components/DrawFlow";
Vue.use(DrawFlow);

const MULTI_USER_APPROVE_TYPE = "FlowApprovalType"; // 多人审批方式
export default {
  components: { userItem, conditionTestDlg, exprEditDlg },
  props: {
    viewMode: { type: Number, default: EditMode.CREATE_0 },
    screenShot: { type: Boolean, default: false }
  },
  data () {
    return {
      EditMode: EditMode,
      stepName: "nodeSet",
      titleDialog: false, // 发起人节点配置
      configDialog: false, // 流程配置页
      conditionDialog: false, // 条件分支设置
      initiateRules: {
        title: [{ required: true, message: "请输入发起人名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入发起人标签", trigger: "blur" }]
      },
      nodeRules: {
        title: [{ required: true, message: "请输入节点名称", trigger: "blur" }]
      },
      conditionRules: {
        title: [{ required: true, message: "请输入条件名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入表达式", trigger: "blur" }],
        conditional: [{ required: true, message: "请输入表达式说明", trigger: "blur" }]
      },
      // 发起人
      initiateForm: {
        title: "", // 节点名称
        nodeKey: "", // 节点标签
        content: ""
      },
      // 数据从流程图带过来的，当前只为展示使用
      nodeForm: {
        title: "", // 节点名称
        nodeKey: "", // 节点标签
        content: "",
        conditional: "",
        data: {
          assigneeSelectionStrategy: "0", // 审批人设置
          runtimeSelectUsers: 0, // 审批时才决定处理人
          assigneeList: [], // 审批人
          multiUserDealStrategy: 2,
          ccList: [], // 抄送人
          ccOptional: 0, // 允许申请人自选抄送人
          ccOneself: 0, // 抄送给申请人本人
          allowAddNode: 0,
          formFieldPermissionList: [] // 字段权限
        }
      },
      // 数据从流程图带过来的，当前只为展示使用
      conditionForm: {
        title: "", // 分支名称
        content: "", // 条件表达式
        conditional: "", // 分支说明
        nodeKey: ""
      },
      assigneeSelectionStrategyList: [],
      multiUserDealStrategyList: [],
      nodeKeyDisabled: false,
      fieldListPermission: [],
      codePri: [] // 选人
    };
  },
  computed: {
    // 是否展示 审批人
    showAssigneeList() {
      const type = this.assigneeSSNumber;
      return type === "0" || type === "3" || type === "6" || type === "7" ;
    },
    // 选择的审批人的列表： 用户/项目角色
    assigneeUserList() {
      return this.nodeForm.data.assigneeList;
    },
    // 选择的抄送人的列表
    ccUserList() {
      return this.nodeForm.data.ccList;
    },
    isReadonly() {
      return this.viewMode === 2;
    },
    FlowConfig() {
      return this.viewMode !== 0 ? getFlowNode() : defaultInitFlowConfig;
    },
    // 选择的字段权限列表
    formFieldPermissionList() {
      const list = this.nodeForm.data.formFieldPermissionList?.map(e => {
        return {
          ...e, isEnabled: e.isEnabled || 0
        };
      }) || [];
      return list;
    },
    permissionTreeList() {
      const list = [];
      for (const iterator of this.formFieldPermissionList) {
        if (iterator.isCanView === 0 || iterator.isCanUpdate === 1 || iterator.isRequired === 1) {
          iterator.isEnabled = 1;
        }
        if (iterator.type === "custom-sub-form") {
          iterator.children = [];
          iterator.isCanUpdate = 1;// 后期会去掉
        }
        if (!iterator.parentContainer) {
          list.push(iterator);
        }
      }
      const childFormList = this.formFieldPermissionList.filter(e => e.parentContainer);
      for (const childWidget of childFormList) {
        for (const widget of list) {
          if (widget.formField === childWidget.parentContainer) {
            widget.children.push(childWidget);
          }
        }
      }
      return list;
    },
    // 审批人设置绑定的enName
    assigneeSSNumber() {
      return this.nodeForm.data.assigneeSelectionStrategy;
    },
    // 模拟修改审批人设置列表--此时后端没开发人员，前端暂时修改
    mockassigneeList() {
      return this.assigneeSelectionStrategyList.map(e => {
        if (e.cnName === "申请人主管") {
          return { ...e, cnName: "申请人的部门主管" };
        } else { return e; }
      });
    }
  },
  methods: {
    // 流程图节点点击 type // 1发起人 2节点 3条件框
    clickFlowNode(node) {
      const { type, conditionRank } = node;
      if (type === "1") {
        this.initiateForm = { ...node };
        this.titleDialog = true;
      } else if (type === "2") { // 打开节点
        this.nodeForm = { ...node };
        console.log("this.nodeForm ", this.nodeForm.data.formFieldPermissionList[2]);
        this.getNodeList();
      } else if (type === "3") { // 默认分支不可操作
        if (conditionRank !== 9999) {
          this.conditionForm = { ...node };
          this.conditionDialog = true;
        }
      }
    },
    // 获取节点设置的一些字典数据(审批人设置/多人审批方式)然后打开抽屉数据
    async getNodeList() {
      if (this.assigneeSelectionStrategyList.length === 0) {
        await this.getAssigneeList();
      }
      if (this.multiUserDealStrategyList.length === 0) {
        await this.getmultiUser();
      }
      // console.log("字典：", this.assigneeSelectionStrategyList);
      this.configDialog = true;
      this.stepName = "nodeSet";
    },
    // 审批人设置列表
    async getAssigneeList() {
      const res = await flowService.queryAssigneeStrategies();
      this.assigneeSelectionStrategyList = res.data || [];
    },
    // 多人审批方式列表
    async getmultiUser() {
      const res = await dicService.getDicList(MULTI_USER_APPROVE_TYPE);
      this.multiUserDealStrategyList = res.data.map((ele) => {
        return {
          ...ele,
          enName: Number(ele.enName)
        };
      });
    },
    onSaveFieldList() {
      this.changNode();
    },
    onIsEnabled(row) {
      if (row.isEnabled !== 1) {
        row.isCanView = 1;
        row.isCanUpdate = 0;
        row.isRequired = 0;
      }
      this.changNode();
    },
    // 更新当前节点权限,之前已有的权限做保存
    async updateAuthority() {
      // 当前的节点权限列表
      const fieldListPermission = this.formFieldPermissionList;
      // 表单所有的字段
      const list = getFormFieldList();
      const newFieldList = [];
      for (const iterator of list) {
        if (fieldListPermission.some(f => f.formField === iterator.formField)) {
          const obj = fieldListPermission.find(f => f.formField === iterator.formField);
          obj.parentContainer = iterator.parentContainer;
          newFieldList.push(obj);
        } else {
          newFieldList.push(iterator);
        }
      }
      this.nodeForm.data.formFieldPermissionList = newFieldList || [];
      await this.$nextTick();
      this.changNode();
    },
    // 审批人设置修改时
    changAssNumber() {
      this.nodeForm.data.assigneeList = [];
      this.changNode();
    },
    // 发起人信息修改
    changInitiateNode() {
      this.$refs.flow.nodeChange(this.initiateForm);
      this.updateflowParams();
    },
    // 改变当前节点的流程图信息
    changNode() {
      const assNumber = this.assigneeSSNumber;
      // 申请人本身，申请人自选，申请人主管
      if (assNumber !== "0" && assNumber !== "3" && assNumber !== "6" && assNumber !== "7") {
        this.nodeForm.content = this.getDefaultAssigneeList();
        this.nodeForm.data.assigneeList = [];
      } else {
        const userAssigneeList = this.nodeForm.data.assigneeList || [];
        if (userAssigneeList.length > 0) {
          const contentList = userAssigneeList.map(e => e.name);
          this.nodeForm.content = `${contentList[0]}${contentList.length >= 2 ? "等" : ""}`;
        } else {
          this.nodeForm.content = "";
        }
      }
      // 不是程序自定义不加节点描述
      if (assNumber !== "5") {
        this.nodeForm.conditional = "";
      }
      const permissionArray = this.permissionTreeList;
      for (const iterator of permissionArray) {
        console.log(iterator?.children);
        if (iterator?.children && iterator?.children.length > 0) {
          for (const item of iterator?.children) {
            permissionArray.push(item);
          }
          iterator.children = [];
        }
      }
      this.nodeForm.data.formFieldPermissionList = this.formFieldPermissionList.map(e => {
        return permissionArray.filter(i => i.formField === e.formField)[0];
      });
      // console.log("object", this.nodeForm.data.formFieldPermissionList);
      this.$refs.flow.nodeChange(this.nodeForm);
      this.updateflowParams();
    },
    // 审批人设置处理审批人
    getDefaultAssigneeList() {
      const assNumber = this.assigneeSSNumber;
      return this.assigneeSelectionStrategyList.find(e => e.enName === assNumber).cnName;
    },
    // 改变当前分支的流程图信息
    changeCondition() {
      this.$refs.flow.nodeChange(this.conditionForm);
      this.updateflowParams();
    },
    // 获取流程图数据
    updateflowParams () {
      updateNode(this.$refs.flow.getResData());
    },
    deleteAssUser(user) {
      this.nodeForm.data.assigneeList = this.nodeForm.data.assigneeList.filter(e => e.userId !== user.userId);
      this.changNode();
    },
    deleteCCUser(user) {
      this.nodeForm.data.ccList = this.nodeForm.data.ccList.filter(e => e.userId !== user.userId);
      this.changNode();
    },
    // 审批人 人员选择
    async openAssPerson() {
      // 审批人设置是 指定成员 或部门主管的选择人员权限时
      if (this.assigneeSSNumber === "0" || this.assigneeSSNumber === "3") {
        this.codePri = ["User", "SystemRole", "SpecRole", "PrjRole"];
      } else if (this.assigneeSSNumber === "6") {
        this.codePri = ["Label"];
      } else if (this.assigneeSSNumber === "7") {
        this.codePri = ["Dept"];
      }
      const props = {
        filterOneself: false,
        max: 100,
        codePri: this.codePri,
        usersList: this.nodeForm.data.assigneeList
      };
      const val = await openMember(props);
      this.nodeForm.data.assigneeList = val || [];
      this.changNode();
    },
    // 抄送人 人员选择
    async openCCPerson() {
      this.codePri = ["User", "SystemRole", "SpecRole", "PrjRole"];
      const props = {
        filterOneself: false,
        codePri: this.codePri,
        usersList: this.nodeForm.data.ccList
      };
      const val = await openMember(props);
      this.nodeForm.data.ccList = val || [];
      this.changNode();
    },
    closeNode() {
      this.updateflowParams();
    },
    // 关闭发起人配置
    titleClose() {
      this.titleDialog = false;
    },
    // 关闭流程配置页
    configClose() {
      this.configDialog = false;
    },
    // 关闭条件分支设置
    conditionClose() {
      this.conditionDialog = false;
    },
    async openExprEditor() {
      const basicForm = flowParams.basicForm;
      const formCode = basicForm.formApprovePcCode || basicForm.formCode;
      if (!formCode) {
        this.$error("请先选择表单");
        return;
      }
      const res = await metadataService.queryFormMetaName(formCode);
      const metaName = res.data || "";
      const params = {
        exprJoinOp: "and",
        exprGroupList: [],
        keyTableId: metaName,
        valTableId: metaName
      };
      this.$refs.exprEditDlg.show(params);
    },
    // 调用后台接口，生成 QL 表达式
    async finishEditExpr(data) {
      const res = await flowService.genQLExpr(data);
      this.conditionForm.content = res.data?.expr || "";
      this.changeCondition();
    },
    testConditionExpr() {
      if (!this.conditionForm.content) {
        this.$warn("请输入表达式");
        return;
      }
      this.$refs.conditionTestDlg.show(this.conditionForm.content);
    }
  }
};
</script>

<style lang="scss" scoped>
#DrawFlow {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  box-sizing: border-box;
}

.oper {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.configPage {
  height: 100%;
  padding: 0 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  .configList{
    flex: 1 1;
    overflow-y: auto;
  }
  .updateFieId {
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 14px;
  }
}

.tips {
  cursor: pointer;
  color: var(--theme-color);
  font-size: 16px;
}

.addPeople {
  margin-left: 5px;
}

.ccTop {
  border-top: 2px dashed #ccc;
  padding-top: 10px;
}

.itemLabel {
  margin-left: 5px;
  font-size: 14px;
}

.readOnly {
  /deep/.add-node-btn {
    visibility: hidden;
  }

  /deep/.showClose {
    display: none;

    i {
      visibility: hidden;
    }
  }

  /deep/.branch-box {
    margin-top: 0;

    .add-branch {
      display: none;
    }
  }
}

.help {
  color: #888;
  line-height: 22px;
}
</style>
<style lang="scss">
.bgcDrawer{
  .el-drawer__header {
    background-image: linear-gradient(90deg, #006EFF, #00C0FF);
    color: #fff;
  }

}
</style>
